import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger
} from '@/components/ui/hover-card'
import { cn } from '@/lib/utils'
import { HelpCircle } from 'lucide-react'
import type { ReactNode } from 'react'

interface PlainExplainProps {
  children: ReactNode
  className?: string
  iconSize?: number
  side?: 'top' | 'right' | 'bottom' | 'left'
  trigger?: ReactNode
}

export function PlainExplain({
  children,
  className,
  iconSize = 14,
  side = 'top',
  trigger
}: PlainExplainProps) {
  return (
    <HoverCard openDelay={120} closeDelay={120}>
      <HoverCardTrigger asChild>
        {trigger ?? (
          <button
            type="button"
            aria-label="What does this do?"
            className={cn(
              'inline-flex size-5 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
              className
            )}
          >
            <HelpCircle style={{ width: iconSize, height: iconSize }} />
          </button>
        )}
      </HoverCardTrigger>
      <HoverCardContent side={side} className="w-72 text-sm leading-relaxed">
        {children}
      </HoverCardContent>
    </HoverCard>
  )
}
